














































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import BankIdQR from '@signing-page/signing/components/modals/steps/BankIdQR.vue';
import BankIdSameDevice from '@signing-page/signing/components/modals/steps/BankIdSameDevice.vue';
import { IBankId } from '@signing-page/signing/types/bankid';
import { EBankIdSigningType, EBankIdStep } from '@signing-page/signing/types/enums/bankid-se';
import BankIdStart from '@signing-page/signing/components/modals/steps/BankIdStart.vue';
import BankIdError from '@signing-page/signing/components/modals/steps/BankIdError.vue';
import BankIdSigned from '@signing-page/signing/components/modals/steps/BankIdSigned.vue';
import BankIdSsn from '@signing-page/signing/components/modals/steps/BankIdSsn.vue';
import { InputType } from '@/enums/InputType';

@Component({
  components: {
    BankIdStart,
    BankIdError,
    BankIdSigned,
    BankIdSameDevice,
    BankIdQR,
    BankIdSsn,
  },
  data: () => ({
    InputType,
    EBankIdStep,
  }),
})
export default class BankIdSe extends Vue {
  @Action('setBankIdState', { namespace: 'signing' }) setBankIdState: any;
  @Action('cancelBankIdTransaction', { namespace: 'signing' }) cancelBankIdTransaction: any;
  @Action('startBankIdTransaction', { namespace: 'signing' }) startBankIdTransaction: any;
  @Prop() bankId!: IBankId;
  @Prop() jwt!: string;

  @Watch('bankId.step')
  isCompleted() {
    if (this.bankId.step === EBankIdStep.Completed) {
      this.$emit('sign');
    }
  }

  get bankIdError(): string {
    return !!this.bankId && this.bankId.error;
  }

  get showStart(): boolean {
    const { signingType, step } = this.bankId;
    return signingType === EBankIdSigningType.None && step === EBankIdStep.Start;
  }

  get showQR(): boolean {
    const { signingType, step } = this.bankId;
    return signingType === EBankIdSigningType.QR && step === EBankIdStep.Polling;
  }

  get showSameDevice(): boolean {
    const { signingType, step } = this.bankId;
    return (
      signingType === EBankIdSigningType.SameDevice &&
      [EBankIdStep.Start, EBankIdStep.Polling].includes(step)
    );
  }

  get showSSN(): boolean {
    const { signingType, step } = this.bankId;
    return (
      signingType === EBankIdSigningType.SSN &&
      [EBankIdStep.Start, EBankIdStep.Polling].includes(step)
    );
  }

  get showSigned(): boolean {
    return this.bankId.step === EBankIdStep.Signed;
  }

  get showError(): boolean {
    return this.bankId.step === EBankIdStep.Failed;
  }

  async handleSetQR(): Promise<void> {
    await this.startBankIdTransaction();
    if (this.bankId.step !== EBankIdStep.Failed) {
      this.setBankIdState({ step: EBankIdStep.Polling, signingType: EBankIdSigningType.QR });
    }
  }

  async handleSetSameDevice(): Promise<void> {
    await this.startBankIdTransaction();
    if (this.bankId.step !== EBankIdStep.Failed) {
      this.setBankIdState({
        step: EBankIdStep.Polling,
        signingType: EBankIdSigningType.SameDevice,
      });
    }
  }

  handleSetSSN(): void {
    this.cancelBankIdTransaction();
    this.setBankIdState({ step: EBankIdStep.Start, signingType: EBankIdSigningType.SSN });
  }

  async handleReset(ssn = ''): Promise<void> {
    await this.cancelBankIdTransaction(ssn);
    this.setBankIdState({ step: EBankIdStep.Start, signingType: EBankIdSigningType.None });
  }

  async handleStartSSN(ssn: string): Promise<void> {
    this.setBankIdState({ step: EBankIdStep.Polling, signingType: EBankIdSigningType.SSN });
    await this.startBankIdTransaction(ssn);
  }
}
